module.exports = __webpack_public_path__ + "img/f8b8cbb.jpg";